/* eslint-disable */
import React, { memo } from 'react';
import s from './cards.module.css';
import { Ico } from '../ShellIcons';
import { SmartImg, computeContentCenter } from '../../../utils';
import AnnounceButton from '../../system/AnnounceButton';
import { useShellStore } from '../shellStore';

// ============================================================
// OriginalsCardV3 — the approved prototype's Originals tile (CLB-012 v3 · S3)
// on OriginalsCard's prop contract: item · isSelected · isFav · linkedCount ·
// priority · hoverPreviewEnabled · onOpen · onToggleSelect · onToggleFav ·
// onHoverPreview · onHoverPreviewEnd. Seven facts in one card: brand + SKU on
// the strip, the photo with the checkbox, the star, the dev-link count and
// the photo count, then shape · gender · material chips and Sun / Optic.
// Selected = amber ring, never black.
// ============================================================

const PLACEHOLDER = (
  <svg viewBox="0 0 140 64" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
    <ellipse cx="44" cy="32" rx="30" ry="21" /><ellipse cx="96" cy="32" rx="30" ry="21" /><path d="M74 32h-8M14 27 2 22M126 27l12-5" />
  </svg>
);

export function itemLine(item) {
  const v = String(item.frameCategory || item.type || item.category || '');
  return /sun/i.test(v) ? 'Sun' : /opt/i.test(v) ? 'Optic' : '';
}

export const OriginalsCardV3 = memo(function OriginalsCardV3({
  item, isSelected, isFav, linkedCount = 0, priority = false, hoverPreviewEnabled = true,
  onOpen, onToggleSelect, onToggleFav, onHoverPreview, onHoverPreviewEnd,
}) {
  const density = useShellStore((st) => st.density);
  const imgs = (item.images || []).length > 0 ? item.images : (item.image ? [item.image] : []);
  const shape = item.shape1 || item.shape || '';
  const gender = item.gender || '';
  const material = item.material || '';
  const line = itemLine(item);
  const stop = (fn) => (e) => { e.stopPropagation(); fn && fn(); };

  return (
    <article
      className={`${s.card} ${s.orig} ${density === 'compact' ? s.compact : ''} ${isSelected ? s.sel : ''}`}
      tabIndex={0} role="button" aria-label={`${item.brand || '—'} ${item.sku || ''}`} aria-pressed={isSelected}
      data-test={`item-card-${item.id}`}
      onClick={onOpen}
      onKeyDown={(e) => { if (e.key === 'Enter' && e.target === e.currentTarget) onOpen && onOpen(e); if (e.key === ' ' && e.target === e.currentTarget) { e.preventDefault(); onToggleSelect && onToggleSelect(); } }}
      onMouseEnter={(e) => { if (hoverPreviewEnabled && onHoverPreview) { const r = e.currentTarget.getBoundingClientRect(); onHoverPreview({ item, x: r.left + r.width / 2, y: r.top }); } }}
      onMouseLeave={() => onHoverPreviewEnd && onHoverPreviewEnd()}
    >
      <div className={s.cTop}>
        <span className={s.brandT} title={item.brand || ''}>{item.brand || '—'}</span>
        {item.sku ? <span className={s.sku}>{item.sku}</span> : null}
      </div>
      <div className={s.cImg}>
        {imgs.length > 0
          ? <SmartImg src={imgs[0]} displayWidth={300} alt={item.brand || ''} priority={priority} className={s.photo} onLoad={(e) => computeContentCenter(e.target, imgs[0])} />
          : <span className={s.ph}>{PLACEHOLDER}</span>}
        <span className={s.floor} /><span className={s.shine} />
        <div className={s.tl}>
          <button type="button" className={`${s.cb} ${s.hoverOnly}`} role="checkbox" aria-checked={isSelected} aria-label={isSelected ? 'Deselect' : 'Select'} onClick={stop(onToggleSelect)}><Ico name="check" /></button>
        </div>
        <div className={s.tr}>
          <button type="button" className={`${s.star} ${s.hoverOnly} ${isFav ? `${s.on} ${s.keep}` : ''}`} aria-pressed={!!isFav} aria-label={isFav ? 'Unmark' : 'Mark'} onClick={stop(onToggleFav)}><Ico name="star" /></button>
          <AnnounceButton portal="catalog" className={`${s.tool} ${s.hoverOnly}`} dataTest={`item-announce-${item.id}`}
            makeSeed={() => ({ kind: 'item', id: String(item.id), code: item.sku || '', name: item.brand || '', image: imgs[0] || null })} />
        </div>
        <div className={s.bl}>{linkedCount > 0 ? <span className={`${s.tag} ${s.amber}`} title={`${linkedCount} development${linkedCount === 1 ? '' : 's'} based on this original`}><Ico name="back" />{linkedCount} dev{linkedCount === 1 ? '' : 's'}</span> : null}</div>
        <div className={s.br}>{imgs.length > 1 ? <span className={`${s.tag} ${s.hoverOnly}`}>{imgs.length} pics</span> : null}</div>
      </div>
      <div className={s.cBody}>
        <div className={s.r2}>
          {shape ? <span className={`${s.fchip} ${s.amber}`}>{shape}</span> : null}
          {gender ? <span className={s.fchip}>{gender}</span> : null}
          {material ? <span className={s.fchip}>{material}</span> : null}
          {!shape && !gender && !material ? <span className={s.fchip}>—</span> : null}
          {line ? <span className={s.meta}><b>{line}</b></span> : null}
        </div>
      </div>
    </article>
  );
});

export default OriginalsCardV3;
